export default __webpack_public_path__ + "static/media/vk.7d556520.png";